import { administrador } from './permissoes/administrador'
import { secretario } from './permissoes/secretario'
import { acs } from './permissoes/acs'
import { auxEnfermagem } from './permissoes/auxEnfermagem'
import { enfermeiro } from './permissoes/enfermeiro'
import { medico } from './permissoes/medico'
import { odontologo } from './permissoes/odontologo'
import { recepcionista } from './permissoes/recepcionista'
import { coordenador } from './permissoes/coordenador'
import { farmaciaOutros } from './permissoes/farmaciaOutros'
import { ace } from './permissoes/ace'
import { coordenador_vigilancia_saude } from './permissoes/coordenador_vigilancia_saude'
import { coordenador_imunizacao } from './permissoes/coordenador_imunizacao'
import { vacinador } from './permissoes/vacinador'
import { tec_aux_saude_bucal } from './permissoes/tec_aux_saude_bucal'
import { profissional_emulti } from './permissoes/profissional_emulti'
import { suporte } from './permissoes/suporte'

export const pagesCategory = [
  { key: 'dashboard', value: 'Página inicial' },
  { key: 'administracao', value: 'Administração' },
  { key: 'gestao_cadastros', value: 'Gestão cadastros' },
  { key: 'visitas_domiciliares', value: 'Visitas domiciliares' },
  { key: 'imunizacao', value: 'Imunização' },
  { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
  { key: 'indicadores_aps', value: 'Indicadores APS' },
  { key: 'pre_natal', value: 'Pré-natal' },
  { key: 'doencas_cronicas', value: 'Doenças crônicas' },
  { key: 'desempenho_por_equipe', value: 'Desempenho por equipe' },
  { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
  { key: 'saude_crianca', value: 'Saúde criança' },
  { key: 'producao', value: 'Produção' },
  { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
  { key: 'bpa_e_ras', value: 'Bpa e Ras' },
  { key: 'esf_eap', value: 'eSF / eAP' },
  { key: 'emulti', value: 'eMulti' },
  { key: 'indicadores_esb', value: 'eSB' },
  { key: 'saude_bucal', value: 'Saúde bucal' },
  { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
  { key: 'upa', value: 'UPA' },
  { key: 'administracao_importar_dados', value: 'Importar Dados' },
]

export const permissoes = [
  secretario,
  administrador,
  acs,
  auxEnfermagem,
  enfermeiro,
  medico,
  odontologo,
  recepcionista,
  coordenador,
  farmaciaOutros,
  ace,
  coordenador_vigilancia_saude,
  coordenador_imunizacao,
  vacinador,
  tec_aux_saude_bucal,
  profissional_emulti,
  suporte,
]
